import script from "./StylingAndComfortStockVehicle.vue?vue&type=script&setup=true&lang=js"
export * from "./StylingAndComfortStockVehicle.vue?vue&type=script&setup=true&lang=js"

import "./StylingAndComfortStockVehicle.vue?vue&type=style&index=0&id=63fbe2c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63fbe2c3"]])

export default __exports__